export default "__VITE_ASSET__d8ee5cf3__"